import { useDialogActions } from "@hg/dialog-sdk"
import type { DialogueData } from "../types"

export const useDialogControl = () => {
    const actions = useDialogActions()

    const startDialogue = (
        dialogues: DialogueData[],
        onComplete?: () => void
    ) => {
        actions.startDialogue(dialogues, onComplete)
    }

    const nextDialogue = () => {
        actions.nextDialogue()
    }

    const hideDialogue = () => {
        actions.hideDialogue()
    }

    const setSpeed = (speed: number) => {
        actions.setTypewriterSpeed(speed)
    }

    return {
        startDialogue,
        nextDialogue,
        hideDialogue,
        setSpeed,
    }
}
